import { useConfigStore } from '@/providers/ConfigStoreProvider';
import { Currency } from '@common/model/apiClient/Currency';
import { Locale } from '@common/model/apiClient/Locale';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'next/navigation';
import { useEffect } from 'react';

let didHydrate = false;

const useHydrateStore = () => {
  const { setCurrency, currency } = useConfigStore((s) => s);
  const params = useParams<{ locale: string }>();
  const locale = params?.locale;
  const currencyData = useQuery({
    queryKey: ['currencies_not_deleted'],
    queryFn: () => Currency.list(),
    refetchOnWindowFocus: false,
    refetchInterval: false,
    retry: 1,
    placeholderData: (previousData) => previousData,
  });

  const localeData = useQuery({
    queryKey: ['selected_locale_get_locale', locale],
    queryFn: () => Locale.get(locale!),
    enabled: !!locale && currencyData.isSuccess,
    refetchOnWindowFocus: false,
    refetchInterval: false,
    placeholderData: (previousData) => previousData,
    retry: 1,
  });

  useEffect(() => {
    if (didHydrate) return;
    if (localeData?.data?.payload?.defaultCurrencyId) {
      const defaultCurrency = currencyData.data?.payload.find((c) => c.iso4217 === localeData.data?.payload.defaultCurrencyId);
      if (!defaultCurrency) {
        return;
      }
      didHydrate = true;
      setCurrency(defaultCurrency);
    }
  }, [currencyData.data?.payload, localeData.data?.payload.defaultCurrencyId, setCurrency]);

  return null;
};

export default useHydrateStore;
